import { useEffect, useState } from "react";
import { Button } from "@/shared/ui/button/Button";
import {
  type ContentCourseModel,
  coursesController,
  coursesStore,
  EditAddCourseSchema,
  CoursesModel,
} from "@/entities";
import { term, termValues } from "@/pages/User/user-add/UserAdd";
import { useFormValues } from "@/shared";
import { UserCoursesAddList } from "../user-courses-add/UserCoursesAddList";

import styles from "./UserCursesList.module.scss";

type Props = {
  userId: string;
  contentCourses: ContentCourseModel[];
  courseId?: string,
};

const UserCursesList = ({ userId, contentCourses, courseId }: Props) => {
  const coursesList = coursesStore((state) => state.coursesList);
  const coursesLoadingSubmit = coursesStore((state) => state.loadingSubmit);
  const [selectCourse, setSelectCourse] = useState<CoursesModel | null>(null);
  const [initCourseId, setInitCourseId] = useState(0);
  const {
    values,
    changeInputs,
    setInitValues,
    errors,
    validateValues,
    resetInput,
  } = useFormValues({
    initValues: {
      price: "",
      course_id: 0,
      duration: 0,
    },
    payloadSchema: EditAddCourseSchema,
  });

  useEffect(() => {
    const numberOfCourseId = Number(courseId)
    if (!isNaN(numberOfCourseId)) {
      setInitCourseId(numberOfCourseId)
    }
  }, [courseId, userId])

  const contentCoursesIds = () => contentCourses.map((item) => item.course_id);

  const getDisabledIds = () => {
    return contentCourses.filter((item, index, array) => {
      if (array.indexOf(item) === index) {
        return new Date(item.expiration_date) > new Date()
      }
    }).map(item => item.course_id)
  }

  const resetCoursesSelect = () => {
    if (coursesList.length === 0) return;
    const filterCoursesList = coursesList.filter(
      (item) => !contentCoursesIds().includes(item.id)
    );
    setInitValues({
      course_id: 0,
      duration: 0,
      price: "",
    });
  };

  const submit = () => {
    const payload = validateValues();
    if (!payload) return;

    coursesController
      .addUserCourse({
        course_id: payload.course_id,
        duration: termValues[term[values.duration]],
        price: values.price ? Number(values.price) : 0,
        user_id: Number(userId),
      })
      .then((status) => {
        if (status === "success") {
          resetInput();
          setSelectCourse(null);
          setInitCourseId(0);
          coursesController.getUsersContentCourses(String(userId));
        }
      });
  };

  const getCourseName = () => {
    const name = coursesList.find((item) => item.id === values.course_id)?.name;
    return name ? name : "";
  };

  const changeCoursesId = (name: string) => {
    const currentId = coursesList.find((item) => item.name === name)?.id;
    if (!currentId) return;
    changeInputs(currentId, "course_id");
  };

  const getSelectListCourses = () => {
    return coursesList
      .filter((item) => !getDisabledIds().includes(item.id))
      .map((item) => item.name);
  };

  

  return (
    <>
        <section className={styles.cursesListRoot}>
          <div className={styles.cursesListWrapper}>
            <UserCoursesAddList
              disabledIds={getDisabledIds()}
              selectCourse={selectCourse}
              handleselectCourse={(value) => setSelectCourse(value)}
              error={String(errors.course_id)}
              changeCourseId={(value) => changeInputs(value, "course_id")}
              price={String(values.price)}
              changePrice={(value) => changeInputs(value, "price")}
              term={term}
              valueTerm={term[values.duration]}
              changeTerm={(value) => changeInputs(value, "duration")}
              initCourseId={initCourseId}
            />
          </div>

          <footer className={styles.submitButtons}>
            <div style={{ maxWidth: 150 }}>
              <Button
                disabled={
                  coursesLoadingSubmit || getSelectListCourses().length === 0
                }
                text="Добавить курс"
                onClick={submit}
                size="small"
              />
            </div>
          </footer>
        </section>
    </>
  );
};

export { UserCursesList };
